__turbopack_context__.v({
  "additionalType": "TypesTable-module__p5p3la__additionalType",
  "additionalTypeDetails": "TypesTable-module__p5p3la__additionalTypeDetails",
  "additionalTypeSummary": "TypesTable-module__p5p3la__additionalTypeSummary",
  "componentDescription": "TypesTable-module__p5p3la__componentDescription",
  "componentName": "TypesTable-module__p5p3la__componentName",
  "returnType": "TypesTable-module__p5p3la__returnType",
  "typeContent": "TypesTable-module__p5p3la__typeContent",
});
